// Nonogram / Picross generator & validator
function runs(arr) {
  const r = [];
  let cnt = 0;
  for (const v of arr) {
    if (v === 1) cnt++;
    else { if (cnt) r.push(cnt); cnt = 0; }
  }
  if (cnt) r.push(cnt);
  return r.length ? r : [0];
}

function runsFilled(arr) {
  return runs(arr.map((v) => (v === 1 ? 1 : 0)));
}

function eqRuns(a, b) {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
}

export function makeNonogram(n, density = 0.55) {
  let sol;
  // avoid fully-empty grid
  do {
    sol = Array.from({ length: n }, () => Array.from({ length: n }, () => (Math.random() < density ? 1 : 0)));
  } while (sol.every((row) => row.every((v) => v === 0)));
  const rowClues = sol.map((row) => runs(row));
  const colClues = [];
  for (let c = 0; c < n; c++) colClues.push(runs(sol.map((row) => row[c])));
  return { n, sol, rowClues, colClues };
}

export function nonogramWin(grid, n, rowClues, colClues) {
  for (let r = 0; r < n; r++) if (!eqRuns(runsFilled(grid[r]), rowClues[r])) return false;
  for (let c = 0; c < n; c++) if (!eqRuns(runsFilled(grid.map((row) => row[c])), colClues[c])) return false;
  return true;
}
